import React from "react";

const SectionTitle = ({
  title,
  color = "primary",
  weight = "normal",
  className = "",
  afterTitle = null,
}) => {
  if (!title) return null;
  return (
    <>
      <h2
        className={`font-openSans text-2xl lg:text-3xl text-${color} 2xl:text-4xl font-${weight} ${className}`}
      >
        {title}
        {afterTitle}
      </h2>
    </>
  );
};

export default SectionTitle;
